import React, { useMemo } from 'react';
import { MdLocationOn, MdEmail } from 'react-icons/md';
import { BsLinkedin, BsGithub } from 'react-icons/bs';
import styles from './Header.module.css';
import { useTheme } from '../context/ThemeContext';

const Header: React.FC = React.memo(() => {
  const { theme } = useTheme();

  const contactLinks = useMemo(() => [
    { 
      icon: <MdEmail />, 
      label: 'Email',
      href: 'mailto:michaelfarrellyjpn@gmail.com',
      ariaLabel: 'Send email'
    },
    { 
      icon: <BsLinkedin />, 
      label: 'LinkedIn',
      href: 'https://linkedin.com/in/mike-farrelly',
      ariaLabel: 'View LinkedIn profile'
    },
    { 
      icon: <BsGithub />,      label: 'GitHub',
      href: 'https://github.com/MikeMikerson',
      ariaLabel: 'View GitHub profile'
    }
  ], []);

  return (
    <header className={styles.header} role="banner">
      <div className={styles.headerContent}>
        <div className={styles.profileInfo}>
          <div className={styles.profileDetails}>
            <div className={styles.nameSection}>
              <h1 id="page-title">Michael Farrelly</h1>
              <p className={styles.title}>Software Engineer</p>
            </div>
            <div className={styles.locationAndContact}>
              <p className={styles.location}>
                <MdLocationOn className={styles.locationIcon} aria-hidden="true" />
                <span>Tokyo, Japan</span>
              </p>
              <div className={styles.contactLinks}>
                {contactLinks.map((link, index) => (
                  <a
                    key={index}
                    href={link.href}
                    className={styles.contactLink}
                    aria-label={link.ariaLabel}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>      </div>
    </header>
  );
});

export default Header;